/** Residents / pending-apps list page sizes (Angular transfer-process pagination). */
export const TRANSFER_LIST_PER_PAGE = [15, 30, 50, 100] as const
